import {
  FaHeartbeat,
  FaUserNurse,
  FaHospitalAlt,
  FaFlask,
  FaPhoneAlt,
  FaMicrochip
} from "react-icons/fa";
import eldercare from "../../assets/Elder tech.png";
import healthsupport from "../../assets/home services.png";
import medicalequipment from "../../assets/medical equipment.png";
import labdiagnostics from "../../assets/labs and logistics.png";
import teleconsultation from "../../assets/Teleconsultation.png";



export { tabsData, data, tabsandpillData,plans,sliderdata,testimonials };


const tabsData = [
 
  {
    id: 1,
    title: "Home Health Care",
    icon: <FaHeartbeat />,
    desc1: "Professional Care, Right at Your Doorstep",
    desc2: "Suvidha brings trusted healthcare home — from nurse visits and health monitoring to vaccinations, nutrition guidance, and hospitalization support. So your loved ones receive timely, dependable care without the stress of travelling.",
    img: eldercare,
  },
  {
    id: 2,
    title: "Health Support",
    icon: <FaUserNurse />,
    desc1: "Daily caregiving services, trained attendants, and post-hospitalization recovery care at home.",
    desc2: "Personalized care plans designed to meet the unique needs of each individual.",
    img: healthsupport,
  },
  {
    id: 3,
    title: "Medical Equipment",
    icon: <FaHospitalAlt />,
    desc1: "Hospital beds, oxygen concentrators, wheelchairs, and medical devices delivered to your home.",
    desc2: "Quality equipment and supplies to support your loved one's healthcare needs.",
    img: medicalequipment,
  },
  {
    id: 4,
    title: "Lab & Diagnostics",
    icon: <FaFlask />,
    desc1: "Blood tests, health checkups, scans, and diagnostic services from the comfort of home.",
    desc2: "Comprehensive diagnostic solutions to ensure your loved ones receive timely and accurate care.",
    img: labdiagnostics,
  },
  {
    id: 5,
    title: "Tele Consultation",
    icon: <FaPhoneAlt />,
    desc1: "Consult experienced doctors anytime through secure video & phone consultations.",
    desc2: "Convenient and accessible healthcare support from the comfort of your home.",
    img: teleconsultation,
  },
  {
    id: 6,
    title: "Elder Tech",
    icon: <FaMicrochip />,
    desc1: "Smart health monitoring devices, emergency alerts, and elder safety technology solutions.",
    desc2: "Innovative technology solutions to enhance the quality of life for seniors.",
    img: eldercare,
  },


];


const data = [
  {
    title: "Celebrating moments with parents",
    img: "https://images.pexels.com/photos/7551686/pexels-photo-7551686.jpeg"
  },
  {
    title: "Caregiver support for parents",
    img: "https://images.pexels.com/photos/7551673/pexels-photo-7551673.jpeg"
  },
  {
    title: "Access healthcare records on app",
    img: "https://images.pexels.com/photos/7578808/pexels-photo-7578808.jpeg"
  },
  {
    title: "Planning celebrations for parents",
    img: "https://images.pexels.com/photos/7089629/pexels-photo-7089629.jpeg"
  },
  {
    title: "Emergency support anytime",
    img: "https://images.pexels.com/photos/6129047/pexels-photo-6129047.jpeg"
  },
  {
    title: "Support for chronic disease care",
    img: "https://images.pexels.com/photos/6129686/pexels-photo-6129686.jpeg"
  },
  {
    title: "Scheduling parents' appointments",
    img: "https://images.pexels.com/photos/7089401/pexels-photo-7089401.jpeg"
  },
  {
    title: "Guidance for the right elder care",
    img: "https://images.pexels.com/photos/7089628/pexels-photo-7089628.jpeg"
  }
];


const tabsandpillData = {
  moh: [
    {
      question: "What services does Suivdha elder care provide?",
      answer:
        "Suivdha offers comprehensive senior living support, including wellbeing programs, daily assistance, community engagement activities, and personalized care plans tailored to each elder’s needs.", 
    },
    {
      question: "Who can benefit from Suivdha elder care services?",
      answer:
        "Senior citizens struggling with daily activities, or those looking for a supportive community and safety assurances while maintaining independence, can benefit from these services.", 
    },
    {
      question: "Can retirees join Suivdha elder care?",
      answer:
        "Yes. Retired individuals looking for comfort, care, and social engagement can join and enjoy facilities that promote both independence and community living.", 
    },
    {
      question: "Is Suivdha elder care only for medical needs?",
      answer:
        "No. Apart from medical support, it also focuses on social engagement, safety, emotional wellbeing, and activities that promote healthy aging.", 
    },
    {
      question: "How does elder care support daily living?",
      answer:
        "Elder care assists with activities such as bathing, dressing, medication reminders, mobility help, nutritious meals, and maintaining hygiene and comfort.", 
    },
    {
      question: "Is emergency assistance available?",
      answer:
        "Yes. Most elder care plans include 24/7 support for emergencies, with quick coordination of medical help and family notifications when needed.", 
    },
    {
      question: "How is safety ensured for residents?",
      answer:
        "Safety is ensured with trained staff, secure premises, fall-prevention measures, regular monitoring, and quick access to healthcare professionals.", 
    },
    {
      question: "Can families customize care plans?",
      answer:
        "Care plans can be customized based on individual health needs, preferences, and level of assistance required, ensuring personalized support.", 
    },
  ],

  general: [
    {
      question: "What is elder care at home?",
      answer:
        "Elder care at home involves providing support with daily activities like meals, bathing, medication management, cleaning, and supervision to help seniors live comfortably in their own home. :contentReference[oaicite:0]{index=0}",
    },
    {
      question: "What kinds of care might an elderly person need?",
      answer:
        "Care can include personal support with daily tasks, medical check-ups, physical therapy, mobility assistance, cognitive activities, and social companionship. :contentReference[oaicite:1]{index=1}",
    },
    {
      question: "How does elder care help with health monitoring?",
      answer:
        "Elder care providers monitor vitals, manage medication reminders, coordinate doctor visits, and help prevent health risks associated with aging. :contentReference[oaicite:2]{index=2}",
    },
    {
      question: "Does elder care include emotional support?",
      answer:
        "Yes. Emotional support, companionship, and social activities are integral to elder care, helping reduce loneliness and depression.", 
    },
    {
      question: "When should a family consider elder care services?",
      answer:
        "Families should consider elder care if a senior struggles with daily tasks, shows memory issues, has mobility limitations, or requires regular monitoring.", 
    },
    {
      question: "Can elders remain independent with care support?",
      answer:
        "Yes. Modern elder care services aim to support independence by assisting with needs while promoting an active lifestyle.", 
    },
    {
      question: "Do elder care services help with nutrition?",
      answer:
        "Many services include assistance with meal planning, nutritious meals, dietary supervision, and support during eating to ensure proper nutrition.", 
    },
    {
      question: "Is there support for cognitive conditions like dementia?",
      answer:
        "Yes. Specialized elder care includes activities, memory support programs, and routines designed to help seniors with dementia stay engaged.", 
    },
  ],

  plans: [
    {
      question: "How do elder care plans work?",
      answer:
        "Elder care plans provide structured support based on senior needs — from basic daily assistance to full-time health and safety supervision.", 
    },
    {
      question: "Can care plans be adjusted over time?",
      answer:
        "Yes. As needs change, care plans can be updated to include more medical care, personal support, or specialized services as required.", 
    },
    {
      question: "What is respite care for seniors?",
      answer:
        "Respite care offers temporary assistance — ideal when caregivers need a break or during times when families are away. :contentReference[oaicite:3]{index=3}",
    },
    {
      question: "What is day care for elders?",
      answer:
        "Day care services engage seniors in social and activity programs while ensuring supervision and basic care during the day. :contentReference[oaicite:4]{index=4}",
    },
    {
      question: "Can elder care help with medical emergencies?",
      answer:
        "Yes. Most plans include emergency response support that coordinates medical help quickly for seniors in need.", 
    },
    {
      question: "Does elder care include physical therapy?",
      answer:
        "Some advanced plans offer physical therapy sessions to help maintain mobility and strength.", 
    },
    {
      question: "Is transportation to appointments provided?",
      answer:
        "Certain care plans include transport assistance for medical checkups and social activities.", 
    },
    {
      question: "How do we start with an elder care plan?",
      answer:
        "Families can contact elder care providers to assess needs, discuss services, customize a plan, and initiate care support.", 
    },
  ],
};

const plans = [
    {
      title: "Elder Monthly Plan - Single",
      text: "Ideal for individuals seeking essential elder care support with flexible monthly billing.",

      pricing: {
        monthly: "₹2,999",
        quarterly: "₹8,099",
        yearly: "₹29,999"
      },

      features: {
        monthly: [
         "24/7 Emergency Coordination",
         "24/7 Ambulance evacuation services",
         "Monthly Dore step visits 1 time (Doctor, Nurse, Lab Technician)",
         "Doctor-on-call in emergencies",
         "Monthly lab tests & teleconsultation (If required the Doctor suggestion)",
         "Access to  physiotherapists",
         "Suvidha Elder Care App for real-time updates",
         "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
         "Help desk for value-added services",
         "Support Care during hospitalization"
        ],

        quarterly: [
         "24/7 Emergency Coordination",
         "24/7 Ambulance evacuation services",
         "Monthly Dore step visits 1 time (Doctor, Nurse, Lab Technician)",
         "Doctor-on-call in emergencies",
         "Monthly lab tests & teleconsultation (If required the Doctor suggestion)",
         "Access to  physiotherapists",
         "Suvidha Elder Care App for real-time updates",
         "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
         "Help desk for value-added services",
         "Support Care during hospitalization"
        ],

        yearly: [
          "24/7 Emergency Coordination",
          "Ambulance evacuation (Twice a year)",
          "Doctor-on-call priority",
          "Quarterly full body checkup",
          "Free teleconsultations",
          "Physiotherapist home visits",
          "Medical equipment discounts",
          "Hospitalization support"
        ]
      }
    },

    

    {
      title: "Elder monthly plan-Couple’s",
      text: "Perfect for couples seeking comprehensive elder care support with flexible monthly billing.",
      highlight: true,

      pricing: {
        monthly: "₹4,999",
        quarterly: "₹13,499",
        yearly: "₹49,999"
      },

      features: {
        monthly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services",
        "Monthly Dore step visits 1 time (Doctor, Nurse, Lab Technician)",
        "Doctor-on-call in emergencies",
        "Monthly lab tests & teleconsultation (If required the Doctor suggestion)",
        "Access to  physiotherapists",
        "Suvidha Elder Care App for real-time updates",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization"
        ],

        quarterly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services",
        "Monthly Dore step visits 1 time (Doctor, Nurse, Lab Technician)",
        "Doctor-on-call in emergencies",
        "Monthly lab tests & teleconsultation (If required the Doctor suggestion)",
        "Access to  physiotherapists",
        "Suvidha Elder Care App for real-time updates",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization"
        ],

        yearly: [
          "Unlimited ambulance support",
          "Doctor priority visits",
          "Bi-monthly home checkups",
          "Annual master health checkup",
          "Free physiotherapy sessions",
          "Medicine delivery",
          "Emergency hospitalization support"
        ]
      }
    },
     {
      title: "Elder Care Premium-Couples",
      text: "Comprehensive care for couples with extensive features and support, billed monthly for flexibility.",

      pricing: {
        monthly: "₹9,999",
        quarterly: "₹26,999",
        yearly: "₹99,990"
      },

      features: {
        monthly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (Monthly 2 times)",
        "Monthly Dore step visits 2 time for slot booking app (Doctor, Nurse, Lab Technician)",
        "Doctor-on-call in emergencies",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion)",
        "Access to physiotherapists",

 "Suvidha Elder Care App for real-time updates",
"Digitalized medical records update in app in real time",
"Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
"Help desk for value-added services",
"Support Care during hospitalization",
"Appointment taken by primary consultant and pickup and dropping assist",
"Expert-led health & wellness sessions",
"Devotional travel booking support (Senior-friendly group travel all our India)",
"Home caretaker supply  assist  (Caretaker, Home making assistance, post-surgical care assist)"
        ],

        quarterly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (Monthly 2 times)",
        "Monthly Dore step visits 2 time for slot booking app (Doctor, Nurse, Lab Technician)",
        "Doctor-on-call in emergencies",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion)",
        "Access to physiotherapists",
        "Suvidha Elder Care App for real-time updates",
        "Digitalized medical records update in app in real time",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization",
        "Appointment taken by primary consultant and pickup and dropping assist",
        "Expert-led health & wellness sessions",
        "Devotional travel booking support (Senior-friendly group travel all our India)",
        "Home caretaker supply  assist  (Caretaker, Home making assistance, post-surgical care assist)"
        ],

        yearly: [
          "24/7 Emergency Coordination",
          "Ambulance evacuation (Twice a year)",
          "Doctor-on-call priority",
          "Quarterly full body checkup",
          "Free teleconsultations",
          "Physiotherapist home visits",
          "Medical equipment discounts",
          "Hospitalization support"
        ]
      }
    },
    

    {
      title: "Elder Care Elite-Couples",
      text: "The ultimate care plan for couples, offering an extensive range of premium features and personalized support, billed monthly for maximum flexibility.",  

      pricing: {
        monthly: "₹14,999",
        quarterly: "₹40,499",
        yearly: "₹99,999"
      },

      features: {
        monthly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (any time)",
        "24/7 Doctor-on-call in emergencies",
        "Monthly Dore step visits -Unlimited for slot booking app (Doctor, Nurse, Lab Technician)",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion 87 parameters)",
        "Access to physiotherapists (weekly four times)",
        "Second opinion Consultation (Monthly one time)",
         "Suvidha Elder Care App for real-time updates",
        "Digitalized medical records update in app in real time",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization (Transport pickup and dropping)",
        "Appointment taken by primary consultant and pickup and dropping assist",
        "Expert-led health & wellness sessions",
        "Devotional travel booking support (Senior-friendly group travel all our India)",
        "Home caretaker supply assist  (Caretaker, Home making assistance, post-surgical care assist)"
        ],

        quarterly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (any time)",
        "24/7 Doctor-on-call in emergencies",
        "Monthly Dore step visits -Unlimited for slot booking app (Doctor, Nurse, Lab Technician)",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion 87 parameters)",
        "Access to physiotherapists (weekly four times)",
        "Second opinion Consultation (Monthly one time)",
         "Suvidha Elder Care App for real-time updates",
        "Digitalized medical records update in app in real time",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization (Transport pickup and dropping)",
        "Appointment taken by primary consultant and pickup and dropping assist",
        "Expert-led health & wellness sessions",
        "Devotional travel booking support (Senior-friendly group travel all our India)",
        "Home caretaker supply assist  (Caretaker, Home making assistance, post-surgical care assist)"
        ],

        yearly: [
          "Unlimited ambulance evacuations",
          "Weekly home visits",
          "Dedicated care manager",
          "Travel assistance",
          "Unlimited lab tests",
          "Mental wellness programs",
          "Post-hospital care"
        ]
      }
    },
     {
      title: "Elder Care Premium - Couples",
      text: "Comprehensive care for couples with extensive features and support, billed monthly for flexibility.",

      pricing: {
        monthly: "₹24,999",
        quarterly: "₹67,499",
        yearly: "₹99,999"
      },

      features: {
        monthly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (any time)",
        "24/7 Doctor-on-call in emergencies",
        "Monthly Dore step visits -Unlimited for slot booking app (Doctor, Nurse, Lab Technician)",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion 87 parameters & CT-Scans if required)",
        "Access to physiotherapists (Unlimited)",
        "Second opinion Consultation (Unlimited)",
         "Suvidha Elder Care App for real-time updates",
        "Digitalized medical records update in app in real time",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization (Transport pickup and dropping personal assistance)",
        "Appointment taken by primary consultant and pickup and dropping assist",
        "Expert-led health & wellness sessions",
        "Devotional travel booking support (Senior-friendly group travel all our India)",
        "Home caretaker diploid 30 days assist (Caretaker, Home making assistance, post-surgical care assist)"

        ],

        quarterly: [
        "24/7 Emergency Coordination services",
        "24/7 Ambulance evacuation services (any time)",
        "24/7 Doctor-on-call in emergencies",
        "Monthly Dore step visits -Unlimited for slot booking app (Doctor, Nurse, Lab Technician)",
        "Monthly lab tests & teleconsultation (Both couples If required the Doctor suggestion 87 parameters & CT-Scans if required)",
        "Access to physiotherapists (Unlimited)",
        "Second opinion Consultation (Unlimited)",
         "Suvidha Elder Care App for real-time updates",
        "Digitalized medical records update in app in real time",
        "Discounts on Extra service for Medical related (Medicine & Medical Equipment)",
        "Help desk for value-added services",
        "Support Care during hospitalization (Transport pickup and dropping personal assistance)",
        "Appointment taken by primary consultant and pickup and dropping assist",
        "Expert-led health & wellness sessions",
        "Devotional travel booking support (Senior-friendly group travel all our India)",
        "Home caretaker diploid 30 days assist (Caretaker, Home making assistance, post-surgical care assist)"
        ],

        yearly: [
          "Unlimited ambulance evacuations",
          "Weekly home visits",
          "Dedicated care manager",
          "Travel assistance",
          "Unlimited lab tests",
          "Mental wellness programs",
          "Post-hospital care"
        ]
      }
    }
  ];

  const sliderdata = [
  {
    img: "/images/emergency.jpg",
    title: "24/7 Emergency Coordination",
    desc: "Round-the-clock support for elders in medical or personal emergencies",
  },
    {
    img: "/images/emergency.jpg",
    title: "24/7 Emergency Coordination",
    desc: "Round-the-clock support for elders in medical or personal emergencies",
  },
    {
    img: "/images/emergency.jpg",
    title: "24/7 Emergency Coordination",
    desc: "Round-the-clock support for elders in medical or personal emergencies",
  },
  {
    img: "/images/app.jpg",
    title: "suvidha App for Real-Time Updates",
    desc: "Real-time updates on your parents' health and safety",
  },
  {
    img: "/images/lab.jpg",
    title: "Annual Lab Tests",
    desc: "Annual lab tests cover vital health parameters",
  },
  {
    img: "/images/doctor.jpg",
    title: "Doctor-on-Call",
    desc: "Connect with a doctor during emergencies",
  },
];


  
const testimonials = [
  {
    name: "Harihar L.",
    img: "/images/testimonial1.jpg",
    text: "Their caregivers gave us peace knowing my father was safe, healthy, and happy at home with thoughtful support every day.",
    video: ""
  },
  {
    name: "S. G.",
    img: "/images/testimonial2.jpg",
    text: "I was stressed being far away, but their team brought calm and care to my mother’s life with genuine support.",
    video: ""
  },
  {
    name: "Mala P.",
    img: "/images/testimonial3.jpg",
    text: "They stepped in during a difficult time and guided our family with professionalism, compassion, and dependable elder care services.",
    video: ""
  },
  {
    name: "Lisa from Memphis",
    img: "/images/testimonial4.jpg",
    text: "Your caregivers became part of our family, making his final days dignified, loving, and filled with care and comfort.",
    video: ""
  },
  {
    name: "Kay from Germantown",
    img: "/images/testimonial5.jpg",
    text: "We are so pleased with the caregiver’s kindness and attention to detail — she made daily life easier and joyful.",
    video: ""
  },
  {
    name: "Angie from East Memphis",
    img: "/images/testimonial6.jpg",
    text: "Their constant care, warmth, and thoughtful support have made our family’s journey easier and more peaceful every day.",
    video: ""
  },
  {
    name: "Shirley K.",
    img: "/images/testimonial7.jpg",
    text: "My mom loves her caregiver — compassionate, consistent, and respectful — giving us reassurance and confidence in her care.",
    video: ""
  },
  {
    name: "David M.",
    img: "/images/testimonial8.jpg",
    text: "The caregiver team went above and beyond, always listening, solving problems, and supporting our loved one with care.",
    video: ""
  }
];